var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMarker',{ref:"marker",attrs:{"coordinates":_vm.coordinates,"draggable":false,"offset":[-10, -40]}},[_c('template',{slot:"marker"},[_c('div',{staticClass:"markerWrapper"},[_c('div',{class:['marker', { isActive: _vm.isActive }]})])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }